import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { BasketUserDetailsStyled } from '../BasketUserDetailsStyled';
import { rem } from 'polished';

export const BasketUserDetailsAC = styled(BasketUserDetailsStyled)`
    .titleWrapper {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .description {
        color: ${({ theme }) => theme.colors.grey5};

        .linkText {
            padding-bottom: unset;
        }
    }

    .form {
        border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.grey2};
    }

    .reinsurance {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        color: ${({ theme }) => theme.colors.grey5};
    }

    .required-section p {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        color: ${({ theme }) => theme.colors.grey1};
    }

    .input-section {
        &-title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }

        input {
            border: 1px solid ${({ theme }) => theme.colors.grey5};
            color: ${({ theme }) => theme.colors.grey5};
            font-size: ${({ theme }) => theme.fontSizes.h4};
            height: ${rem(48)};
            border-radius: ${rem(12)};

            &.error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &-error {
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }
`;
